//// Application Packages
import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { format } from 'date-fns'

//// Application Slices
import { selectSettings } from '../../reducers/settingSlice'
import {
    updateFormData,
    updateFormValidity,
    selectForms,
} from '../../reducers/formSlice'

//// Application Components

//// Carbon Components
import { RadioButton, RadioButtonGroup } from '@carbon/react'

//// Carbon Icons

//// Static Constants

//////// Component
const AdditionalCriminalAndMedicaidMedicareFraudTerminatedOtherStateQuestions =
    () => {
        //////// Hooks
        const dispatch = useDispatch()

        //////// State

        //////// Slices
        const settingsData = useSelector(selectSettings)
        const formsData = useSelector(selectForms)

        //// Slice Data
        const digital_name = settingsData?.['form']?.['digital_name']

        //////// Search Params

        //////// Methods

        // Re-Validate Data Submission
        const revalidation = async (event_name) => {
            // Update Validation State
            if (digital_name && event_name) {
                dispatch(
                    updateFormValidity({
                        digital_name: digital_name,
                        errors: {
                            [event_name]: false,
                            [event_name + 'ErrMsg']: '',
                        },
                    })
                )
            }
        }

        //////// Functional Methods

        // Handle Data Of All Fields + DatePicker (ID)
        const handleData = (e, id) => {
            if (e?.target?.name && e?.target?.value) {
                dispatch(
                    updateFormData({
                        digital_name: digital_name,
                        values: {
                            [e.target.name]: e.target.value,
                        },
                    })
                )
                revalidation(e.target.name)
            } else if (e?.target?.name) {
                dispatch(
                    updateFormData({
                        digital_name: digital_name,
                        values: { [e.target.name]: '' },
                    })
                )
                revalidation(e.target.name)
            } else if (e?.length > 0 && id) {
                dispatch(
                    updateFormData({
                        digital_name: digital_name,
                        values: {
                            [id]: format(new Date(e?.[0]), 'MM/dd/yyyy'),
                        },
                    })
                )
                revalidation(id)
            }
            //// Start Watson Assistant Journey

            //// End Watson Assistant Journey
        }

        //////// Memoization

        //////// Effects/Side Effects

        //////////////// Render & Return
        if (formsData?.[digital_name]?.values?.TRMOSMED === 'Y') {
            return (
                <>
                    <RadioButtonGroup
                        className={
                            formsData?.[digital_name]?.errors?.TRMOSMED4A
                                ? 'required invalid'
                                : 'required'
                        }
                        defaultSelected={
                            formsData?.[digital_name]?.values?.TRMOSMED4A
                        }
                        valueSelected={
                            formsData?.[digital_name]?.values?.TRMOSMED4A
                        }
                        legendText="Have you been in good standing with a state Medicaid program for the most recent five years?"
                        name="TRMOSMED4A"
                        invalid={formsData?.[digital_name]?.errors?.TRMOSMED4A}
                        invalidText={
                            formsData?.[digital_name]?.errors?.TRMOSMED4AErrMsg
                        }
                    >
                        <RadioButton
                            id="TRMOSMED4ATrue"
                            name="TRMOSMED4ATrue"
                            labelText="Yes"
                            value="Y"
                            type="radio"
                            onClick={handleData}
                        />
                        <RadioButton
                            id="TRMOSMED4AFalse"
                            name="TRMOSMED4AFalse"
                            labelText="No"
                            value="N"
                            type="radio"
                            onClick={handleData}
                        />
                    </RadioButtonGroup>

                    <RadioButtonGroup
                        className={
                            formsData?.[digital_name]?.errors?.TRMOSMED4B
                                ? 'required invalid'
                                : 'required'
                        }
                        defaultSelected={
                            formsData?.[digital_name]?.values?.TRMOSMED4B
                        }
                        valueSelected={
                            formsData?.[digital_name]?.values?.TRMOSMED4B
                        }
                        legendText="Did the termination occur at least 20 years before the date of this application?"
                        name="TRMOSMED4B"
                        invalid={formsData?.[digital_name]?.errors?.TRMOSMED4B}
                        invalidText={
                            formsData?.[digital_name]?.errors?.TRMOSMED4BErrMsg
                        }
                    >
                        <RadioButton
                            id="TRMOSMED4BTrue"
                            name="TRMOSMED4BTrue"
                            labelText="Yes"
                            value="Y"
                            type="radio"
                            onClick={handleData}
                        />
                        <RadioButton
                            id="TRMOSMED4BFalse"
                            name="TRMOSMED4BFalse"
                            labelText="No"
                            value="N"
                            type="radio"
                            onClick={handleData}
                        />
                    </RadioButtonGroup>
                </>
            )
        }
    }

export default AdditionalCriminalAndMedicaidMedicareFraudTerminatedOtherStateQuestions
